import React from 'react'
import S from './styles'

const CardsContainer = ({ children, itemsWidth, customStyles }) => {
  return (
    <S.CardsContainer customStyles={customStyles} itemsWidth={itemsWidth}>
      {children}
    </S.CardsContainer>
  )
}

export default CardsContainer
